import type { CroppingProperties } from '@atlassian/jira-common-rest/src/api/2/universal-avatar/type/issuetype/owner/id/types.tsx';
import type { Avatar } from '../model/types.tsx';
import type { Props } from './types.tsx';

// INITIALIZE APP PROPS
export const INITIALIZE_APP_PROPS = 'state.INITIALIZE_APP_PROPS' as const;

export type InitializeAppPropsAction = {
	type: typeof INITIALIZE_APP_PROPS;
	payload: Props;
};

export const initializeAppProps = (payload: Props): InitializeAppPropsAction => ({
	type: INITIALIZE_APP_PROPS,
	payload,
});

// FETCH AVATARS
export const FETCH_AVATARS = 'state.FETCH_AVATARS' as const;

export type FetchAvatarsAction = {
	type: typeof FETCH_AVATARS;
};

export const fetchAvatars = (): FetchAvatarsAction => ({
	type: FETCH_AVATARS,
});

// FETCH AVATARS SUCCESS
export const FETCH_AVATARS_SUCCESS = 'state.FETCH_AVATARS_SUCCESS' as const;

export type FetchAvatarsSuccessAction = {
	type: typeof FETCH_AVATARS_SUCCESS;
	payload: Avatar[];
};

export const fetchAvatarsSuccess = (payload: Avatar[]): FetchAvatarsSuccessAction => ({
	type: FETCH_AVATARS_SUCCESS,
	payload,
});

// FETCH AVATARS FAILURE
export const FETCH_AVATARS_FAILURE = 'state.FETCH_AVATARS_FAILURE' as const;

export type FetchAvatarsFailureAction = {
	type: typeof FETCH_AVATARS_FAILURE;
};

export const fetchAvatarsFailure = (): FetchAvatarsFailureAction => ({
	type: FETCH_AVATARS_FAILURE,
});

export const SHOW_FETCH_AVATARS_ERROR_FLAG = 'state.SHOW_FETCH_AVATARS_ERROR_FLAG' as const;

export type ShowFetchAvatarsErrorFlagAction = {
	type: typeof SHOW_FETCH_AVATARS_ERROR_FLAG;
};

export const showFetchAvatarsErrorFlag = (): ShowFetchAvatarsErrorFlagAction => ({
	type: SHOW_FETCH_AVATARS_ERROR_FLAG,
});

// SAVE AVATAR IMAGE SUCCESS
export const SAVE_AVATAR_IMAGE_SUCCESS = 'state.SAVE_AVATAR_IMAGE_SUCCESS' as const;

export type SaveAvatarImageSuccessAction = {
	type: typeof SAVE_AVATAR_IMAGE_SUCCESS;
	payload: {
		avatar: Avatar;
	};
};

export const saveAvatarImageSuccess = (avatar: Avatar): SaveAvatarImageSuccessAction => ({
	type: SAVE_AVATAR_IMAGE_SUCCESS,
	payload: {
		avatar,
	},
});

// SAVE AVATAR IMAGE FAILURE
export const SAVE_AVATAR_IMAGE_FAILURE = 'state.SAVE_AVATAR_IMAGE_FAILURE' as const;

export type SaveAvatarImageFailureAction = {
	type: typeof SAVE_AVATAR_IMAGE_FAILURE;
};

export const saveAvatarImageFailure = (): SaveAvatarImageFailureAction => ({
	type: SAVE_AVATAR_IMAGE_FAILURE,
});

// SAVE AVATAR IMAGE
export const SAVE_AVATAR_IMAGE = 'state.SAVE_AVATAR_IMAGE' as const;

export type SaveAvatarImageAction = {
	type: typeof SAVE_AVATAR_IMAGE;
	payload: {
		image: File;
		properties: CroppingProperties;
	};
};

export const saveAvatarImage = (
	image: File,
	properties: CroppingProperties,
): SaveAvatarImageAction => ({
	type: SAVE_AVATAR_IMAGE,
	payload: {
		image,
		properties,
	},
});

export type Action =
	| InitializeAppPropsAction
	| FetchAvatarsAction
	| FetchAvatarsSuccessAction
	| FetchAvatarsFailureAction
	| SaveAvatarImageSuccessAction
	| SaveAvatarImageFailureAction
	| SaveAvatarImageAction;
